import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import { dashboardStyles } from '../../Styles/dashboardStyles';
import UserNavbar from './UserNavbar';
import { Switch, Route } from 'react-router-dom';
import StatsComponent from '../Statistics/StatsComponent'
import ManageUsers from '../Admin/ManageUsers'
import UserSettings from '../User/UserSettings';
import UserStatistics from '../Statistics/UserStatistics';
import BlockedList from '../Admin/BlockedList';
import ManageEnterprises from '../Admin/ManageEnterprises';

@inject('statisticsStore', 'userStore')
@observer
class UserHome extends React.Component {
  componentDidMount() {
   
  }

  render() {
    const { classes } = this.props;
    const { user } = this.props.userStore;

    return (
      <div className={classes.dashboardContainer}>
        <UserNavbar  ></UserNavbar>
        <main className={classes.content} >
          <Switch>
          <Route path={this.props.match.url + '/usage'} exact={true} component={ user.userType !== "AGENT" ?  StatsComponent:  UserStatistics  } />
          <Route path={'/admin/manageUsers'} exact={true} component={ManageUsers} />
          <Route path={'/admin/manageEnterprises'} exact={true} component={ManageEnterprises} />
          <Route path={'/user/settings'} exact={true} component={UserSettings} />
          <Route path={'/admin/blockedIPs'} exact={true}component={() => <BlockedList filter="IP" heading="Blocked IP's" active="ip" /> } />
          <Route path={'/admin/blockedDomains'} exact={true} component={() => <BlockedList filter="DOMAIN" heading="Blocked Domains"  active="domain"/>}  />
          </Switch>
        </main>
      </div>
    );
  }
}
export default withStyles(dashboardStyles, { withTheme: true })(withRouter(UserHome));
